import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { routes } from './routes';
import { initAuthListener } from './store/authStore';
import './styles/globals.css';
import './styles/chalk.css';

initAuthListener();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element in index.html');
}

// Router instance is local — keeps the non-portable @remix-run/router type
// from crossing a module boundary. See routes.tsx header comment.
const router = createBrowserRouter(routes);

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
